import React from 'react';
import {Box, Button, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {DeleteOutline} from '@mui/icons-material';
import {alpha} from '@mui/material/styles';
import {SettingsDialog} from '../settings/SettingsDialog';

export default function WorkspaceConfirmationDialog({title, description, confirmLabel, confirm}) {
    return <SettingsDialog open fullWidth maxWidth="xs" onClose={() => confirm(false)}
        aria-labelledby="workspace-confirmation-title" aria-describedby="workspace-confirmation-description"
        sx={{'& .MuiDialog-paper': {borderRadius: '16px', m: 2, width: 'calc(100% - 32px)'}}}>
        <DialogTitle id="workspace-confirmation-title">
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                <Box sx={{display: 'flex', p: 1, borderRadius: '10px', color: 'error.main',
                    bgcolor: theme => alpha(theme.palette.error.main, 0.1)}}><DeleteOutline sx={{fontSize: 22}}/></Box>
                <Box component="span">{title}</Box>
            </Box>
        </DialogTitle>
        <DialogContent>
            <Typography id="workspace-confirmation-description" sx={{fontSize: 14, color: 'text.secondary', overflowWrap: 'anywhere'}}>
                {description}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button color="inherit" autoFocus onClick={() => confirm(false)}>Cancel</Button>
            <Button color="error" variant="contained" onClick={() => confirm(true)}>{confirmLabel}</Button>
        </DialogActions>
    </SettingsDialog>;
}
